import Vue from "vue";
import Router from "vue-router";
import Meta from "vue-meta";
import RouterView from "./views/RouterView";

Vue.use(Router);
Vue.use(Meta);

const routes = [
    {
        path: "career-path",
        props: true,
        name: "CareerPath",
        component: () =>
            import ("./views/CareerPath.vue")
    },
    {
        path: "career",
        props: true,
        name: "Career",
        component: () =>
            import ("./views/Career.vue")
    },
    {
        path: "career-event",
        props: true,
        name: "CareerEvent",
        component: () =>
            import ("./views/CareerEvent.vue")
    },
    {
        path: "career-benefit",
        props: true,
        name: "CareerBenefit",
        component: () =>
            import ("./views/CareerBenefit.vue")
    },
    {
        path: "career-training",
        props: true,
        name: "CareerTraining",
        component: () =>
            import ("./views/CareerTraining.vue")
    },
    {
        path: "jobs",
        props: true,
        name: "Jobs",
        component: () =>
            import ("./views/Jobs.vue")
    },
    {
        path: "jobs/:jobID",
        props: true,
        name: "Job",
        component: () =>
            import ("./views/Job.vue")
    },
    {
        path: "jobs/:jobID/apply",
        props: true,
        name: "apply",
        component: () =>
            import ("./views/Apply.vue")
    },
    {
        path: "jobs/:jobID/confirm",
        props: true,
        name: "confirm",
        component: () =>
            import ("./views/Confirm.vue"),
    },
    {
        path: "jobs/:jobID/thankyou",
        props: true,
        name: "thankyou",
        component: () =>
            import ("./views/ThankYou.vue")
    },
    {
        path: ":home(home)?",
        props: true,
        name: "home",
        component: () =>
            import ("./views/Home.vue")
    }
];

const router = new Router({
    mode: "history",
    base: "/career/",
    routes: [
        {
            path: "/:locale(zh|en)?",
            component: RouterView,
            children: routes
        },
        {
            path: "*", // and finally the default route, when none of the above matches:
            component: () =>
                import ("./views/PageNotFound.vue"),
            meta: {
                metaTags: [
                    {
                        name: 'robots',
                        content: 'noindex'
                    },
                ]
            },
            beforeEnter: (to, from, next) => {
                window.location.href = "/404";
            }
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    }
});

router.beforeEach((to, from, next) => {
    const { locale } = from.params;
    if (locale && !(to.params.locale)) {
        next(`/${locale}${to.path}`);
    }
    next();
});

export default router;
